import { Helmet } from 'react-helmet-async';

const BASE_URL = 'https://ethicalwiki.com';

export default function SEO({ 
  title, 
  description, 
  canonical,
  type = 'website',
  image = null
}) {
  const fullTitle = title 
    ? `${title} | Ethical Wiki` 
    : 'Ethical Wiki - Professional Wikipedia Consulting & Page Creation Services';
  
  const metaDescription = description || 
    'Ethical Wiki provides professional Wikipedia consulting services. We help brands, executives, and organizations navigate Wikipedia ethically with expert guidance on page creation, editing, and reputation management.';
  
  const canonicalUrl = canonical ? `${BASE_URL}${canonical}` : BASE_URL;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDescription} />
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:site_name" content="Ethical Wiki" />
      {image && <meta property="og:image" content={image} />}
      
      {/* Twitter Card */}
      <meta name="twitter:card" content={image ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      {image && <meta name="twitter:image" content={image} />}
    </Helmet>
  );
}
